import { HiQrcode } from "react-icons/hi";

interface IGetStartedButton {
  isScrolled?: boolean;
}
const GetStartedButton = ({ isScrolled }: IGetStartedButton) => {
  // rendering get started button component here
  return (
    <a
      href="/"
      className="group flex items-center justify-center overflow-hidden font-marcellus font-semibold"
    >
      <span
        className={`flex items-center justify-center px-4 py-2 text-legal-white duration-300 group-hover:bg-legal-brown group-hover:text-legal-dark-gray ${isScrolled ? "bg-legal-dark-blue" : "bg-legal-white"} rounded-tl-xl`}
      >
        <HiQrcode
          className={`size-6 duration-500 group-hover:-rotate-180 ${isScrolled ? "text-legal-white" : "text-legal-dark-blue"}`}
        />
      </span>
      <span
        className={`bg-legal-brown text-legal-dark-gray px-4 py-2   duration-300 ${isScrolled ? "group-hover:bg-legal-dark-blue group-hover:text-legal-white" : "group-hover:bg-legal-white group-hover:text-legal-dark-blue"} rounded-br-xl`}
      >
        Let's Get Started
      </span>
    </a>
  );
};

export default GetStartedButton;
